import React, { useState, useMemo, useCallback, useEffect } from 'react';
import Flex from './Flex';
import Typography from './Typographys';
import { PhoneInput } from 'react-international-phone';
import 'react-international-phone/style.css';
import { TYPOGRAPHY } from '../../constants';
import { useThemeContext } from '../../theme/GlobalTheme';

function CustomInputNumber({ label, phone, setPhone, countryC, setCountryCode, readOnly = false }) {
    const { isDark } = useThemeContext();
    const [fullNumber, setFullNumber] = useState(`${countryC} ${phone}`);

    useEffect(() => {
        setFullNumber(countryC.split(' ')[1] + " " + phone)
    }, [])


    const inputClassName = useMemo(() => (
        `!border !border-primaryPurple !w-full !h-10 !font-medium !text-[16px] !max-w-none !rounded-r-lg ${isDark ? '!bg-primaryDark !text-white' : 'bg-[#FCFAFF]'
        }`
    ), [isDark]);

    const countrySelectorStyleProps = useMemo(() => ({
        className: `[&>button]:border [&>button]:p-1 [&>button]:pl-2.5 [&>button]:!h-10 [&>button]:border-primaryPurple [&>button]:!rounded-l-lg ${isDark
            ? '[&>*]:!bg-primaryDark [&>*]:!text-white [&>ul]:border [&>ul]:border-primaryPurple hover:[&>ul>li]:!text-black'
            : 'bg-[#FCFAFF]'
            }`
    }), [isDark]);

    const handleChange = useCallback((phone, meta) => {
        const countryCode = meta.inputValue.split(' ')[0];
        const countryDialCode = meta?.country?.iso2
        let parts = meta.inputValue.split(' ');
        let fullNo = parts.slice(1).join('');
        setCountryCode(`${countryDialCode} ${countryCode}`);
        setPhone(fullNo);


    }, [setCountryCode, setPhone]);

    return (
        <Flex vertical className="gap-1.5 mb-3">
            <Typography text={label} type={TYPOGRAPHY.PARA} />
            <PhoneInput
                inputClassName={inputClassName}
                countrySelectorStyleProps={countrySelectorStyleProps}
                defaultCountry="au"
                value={fullNumber}
                onChange={handleChange}
                disabled={readOnly}
            />
        </Flex>
    );
}

export default React.memo(CustomInputNumber);